module.exports = __webpack_public_path__ + "img/wt4.89ef0640.png";